module.exports = __webpack_public_path__ + "static/img/14000136.99fb770d.png";